<template>
  <el-container class="container" :class="{'embed-mode': fromIframe}">
    <el-header class="header" v-if="!fromIframe">
      <Header></Header>
    </el-header>
    <el-container class="mainContainer">
      <el-aside class="aside" style="width: auto" v-if="!fromIframe">
        <LeftNav></LeftNav>
      </el-aside>
      <el-main class="main">
        <div class="main-div">
          <div v-if="!fromIframe">
            <header-bread></header-bread>
          </div>
          <router-view></router-view>
        </div>
        <portal-target name="local-loading"></portal-target>
      </el-main>
    </el-container>
    <displays-logs v-if="showLogs" :show-dialog="showLogs"></displays-logs>
  </el-container>
</template>

<script>
import LeftNav from "@/components/LeftNav";
import Header from "@/components/Header";
import {copyText} from "@/utils/windowsUtils";
import HeaderBread from "@/components/HeaderBread";
import {getDataInLocalStorage} from "@/utils/localStorage";
import DisplaysLogs from "@/components/logs/DisplaysLogs";
const  otherApiUrl=process.env.VUE_APP_OTHER_API
export default {
  name: "Home",
  components: {DisplaysLogs,HeaderBread,Header, LeftNav},
  data(){
    return{
      showLogs:false,
    }
  },
  mounted() {
    var userAgent = navigator.userAgent.toLowerCase();//判断是否在微信中打开
    if (userAgent.indexOf('micromessenger') !== -1) {
      this.$confirmUi(`用微信内置的浏览器打开网页可能会出现样式错位，影响操作效果。建议用其他浏览器打开。`, '提示', {
        confirmButtonText: `点击复制网页地址`,
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 关键
        copyText(window.location.href)
      }).catch(err => { })
    }
    // 获取用户对新日志读取状态
    fetch(`${otherApiUrl}/person_api/version-log-read/status?uuid=${getDataInLocalStorage('uuid')}&space=bs`,{
      method:'get',
    }).then(res=>res.json()).then(res1=>{
      if(res1.code!==200){
        this.$messageUi.error(res1.msg)
      }
      else {
        if (!res1.data) this.showLogs=true
      }
    }).catch(err => { })
  },
  computed: {
    currentNav() {
      return this.$route.name.split('/')
    },
    fromIframe() {
      return sessionStorage.getItem('fromIframe') === '1';
    }
  }
}
</script>

<style scoped>
.aside {
  height: calc(100vh - 65px);
  background-color: #FFFFFF;
}
.header {
  z-index: 99;
  padding: 0px;
  height: 65px!important;
  /*background-color: rgb(59, 89, 150);*/
  /*background-color: rgb(59, 89, 150);*/
  background-color:#386b94;

}
.el-main {
  height: calc(100vh - 65px);
}
.mainContainer{
  height:  calc(100vh - 65px);
}
.embed-mode .el-main {
  height: 100vh;
  padding: 0;
}
.embed-mode .mainContainer {
  height: 100vh;
}
</style>
